EG.Models = EG.Models || {};

EG.Models.Arrangee = Backbone.Model.extend({
    idAttribute: 'userId'
});

EG.Models.ArrangeeCollection = Backbone.Collection.extend({
    model: EG.Models.Arrangee
});